import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { useGetAssetHolderQuery } from '../../../api-services/asset-holdings/assetHolderApi'
import { type AssetHolderUpdateDto } from '../../../api-schema-types/asset-holdings/AssetHolderCrudDtos'
import { resetEditAssetHolder, selectCurrentAssetHolderId, setCurrentAssetHolderId } from './editAssetHolderSlice'
import EditAssetHolderForm from './EditAssetHolderForm'
import LoadingComponent from '../../components/ui-widgets/LoadingComponent'
import { RtkQueryHelper } from '../../../api-services/shared/RtkQueryHelper'
import ErrorComponent from '../../components/ui-widgets/ErrorComponent'
import CircularProgress from '@mui/material/CircularProgress'
import Refresh from '@mui/icons-material/Refresh'

const EditAssetHolderPage: React.FC = () => {
  const params = useParams<any>()
  const history = useHistory()
  const dispatch = useAppDispatch()

  const currentAssetHolderId = useAppSelector<number | null>(selectCurrentAssetHolderId)

  let assetHolderId: number | null = null
  // let forceRefresh: boolean = false
  let assetHolder: AssetHolderUpdateDto | null = null

  // ================================================================================================================
  // Initialise params
  if (Boolean(params.assetHolderId) && assetHolderId !== '') {
    assetHolderId = params.assetHolderId
  }

  // ================================================================================================================
  // GET Query

  const skipQuery = assetHolderId === null
  const getAssetHolderApiResult = useGetAssetHolderQuery({ assetHolderId }, { skip: skipQuery })
  const refetchAssetHolder = getAssetHolderApiResult.refetch

  if (getAssetHolderApiResult.error !== null && !getAssetHolderApiResult.isLoading && (getAssetHolderApiResult.data != null)) {
    assetHolder = getAssetHolderApiResult.data
  }

  useEffect(() => {
    if (currentAssetHolderId !== assetHolderId) {
      dispatch(resetEditAssetHolder())
      dispatch(setCurrentAssetHolderId(assetHolderId))
    }
  }, [getAssetHolderApiResult.isSuccess])

  // ================================================================================================================
  // Handlers

  const handleRefresh = async (): Promise<void> => {
    await refetchAssetHolder()
  }

  /*  if (params.requestRefresh) {
    // forceRefresh = Boolean(params.forceRefresh)
    void refetchAssetHolder()
  } */

  const isAssetHolderDataLoaded = (): boolean => {
    if (getAssetHolderApiResult.error != null) return false
    if (getAssetHolderApiResult.isLoading) return false
    if (getAssetHolderApiResult.isFetching) return false
    return true
  }

  // ================================================================================================================

  return (
    <>
      <Grid container>
        <Grid item lg={12}>
          <Grid container sx={{ mb: 4 }}>
            <Grid item lg={8}>
              <Typography variant={'h5'}>
                {(assetHolder !== null)
                  ? (
                    <>
                      [{assetHolder.assetHolderId}] {`${assetHolder?.legacyFirstName} ${assetHolder?.legacyLastName}`}
                    </>
                    )
                  : ''
                }
              </Typography>
            </Grid>
            <Grid item lg={4} sx={{ textAlign: 'right' }}>
              <Button variant={'outlined'} onClick={() => history.push('/app/customer-operations')} startIcon={<ArrowBackIcon/>}>
                Customer Operations
              </Button>
            </Grid>
          </Grid>

          <Paper>
            <Box sx={{ p: 4, mt: 3 }}>
               {getAssetHolderApiResult.isLoading && <LoadingComponent/>}
               {(getAssetHolderApiResult.error != null) &&
                <ErrorComponent message={RtkQueryHelper.mapResponseError(getAssetHolderApiResult.error)}/>}
              <Grid container>
                <Grid item lg={12} style={{ textAlign: 'right' }}>
                  <Button variant={'outlined'} onClick={handleRefresh}>
                    { !isAssetHolderDataLoaded() && <CircularProgress size={22} />}
                    { isAssetHolderDataLoaded() && <Refresh/>}
                  </Button>
                </Grid>
              </Grid>

               { isAssetHolderDataLoaded() && getAssetHolderApiResult.data !== null && getAssetHolderApiResult.data !== undefined && (
                <EditAssetHolderForm assetHolder={getAssetHolderApiResult.data} triggerRefetch={handleRefresh} />
               )}
            </Box>

            {/* ==================================================================================================== */}

          </Paper>

        </Grid>
      </Grid>
    </>
  )
}

export default EditAssetHolderPage
